import { render, staticRenderFns } from "./ReLoginOverlay.vue?vue&type=template&id=1ed23dda&"
import script from "./ReLoginOverlay.vue?vue&type=script&lang=js&"
export * from "./ReLoginOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ReLoginOverlay.vue?vue&type=style&index=0&module=true&lang=module.css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports